/* VATNARA PDP V3 — Planwahl, Add-to-Cart (AJAX + UTM-Properties), Galerie-Punkte, Sticky-Leiste. */
(function () {
  var form = document.getElementById('buyForm');
  if (!form) return;
  var idInput = document.getElementById('buyId');
  var cta = document.getElementById('cta');
  var ctaPrice = document.getElementById('ctaPrice');
  var stickyPrice = document.getElementById('stickyPrice');
  var err = document.getElementById('buyErr');

  function current() { return form.querySelector('input[name="plan"]:checked'); }

  form.querySelectorAll('input[name="plan"]').forEach(function (r) {
    r.addEventListener('change', function () {
      form.querySelectorAll('.opt').forEach(function (o) { o.classList.remove('opt--on'); });
      r.closest('.opt').classList.add('opt--on');
      idInput.value = r.value;
      ctaPrice.textContent = r.dataset.price;
      stickyPrice.textContent = r.dataset.price + ' · 60 days to decide';
    });
  });

  var inCart = false;
  function setInCart() {
    cta.textContent = 'In your cart — check out';
    document.getElementById('stickyBtn').textContent = 'Check out';
  }
  form.querySelectorAll('input[name="plan"]').forEach(function (r) { r.addEventListener('change', function () {
    if (!inCart) return;
    inCart = false;
    cta.innerHTML = 'Add to cart · <span id="ctaPrice">' + r.dataset.price + '</span> →';
    ctaPrice = document.getElementById('ctaPrice');
    document.getElementById('stickyBtn').textContent = 'Add to cart';
  }); });
  form.addEventListener('submit', function (e) {
    if (!window.fetch) return;
    e.preventDefault();
    if (inCart) { if (window.VATNARA_OPEN_CART) window.VATNARA_OPEN_CART(); else location.href = '/cart'; return; }
    var label = cta.innerHTML;
    cta.disabled = true; cta.textContent = 'Adding…'; err.textContent = '';
    var fd = new FormData(form);
    fd.delete('plan');
    try { var u = window.VT_UTM || {}; Object.keys(u).forEach(function (k) { fd.append('properties[_' + k + ']', u[k]); }); } catch (x) {}
    try { var a = new URLSearchParams(location.search).get('angle') || 'hair'; fd.append('properties[_pdp]', 'v3-' + a); } catch (x) {} try { if (window.VT_SF && window.VT_SF.length) fd.append('properties[_sf]', window.VT_SF.join(',')); } catch (x) {}
    fetch('/cart/add.js', { method: 'POST', body: fd, headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || 'Please try again.'); return j; }); })
      .then(function () {
        try { if (window.fbq) fbq('track', 'AddToCart', { content_ids: [idInput.value], content_type: 'product', value: parseFloat(current().dataset.price.replace(/[^0-9.]/g, '')), currency: 'USD' }); } catch (x) {}
        inCart = true; setInCart();
        if (window.VATNARA_OPEN_CART) window.VATNARA_OPEN_CART(); else location.href = '/cart';
      })
      .catch(function (e2) { err.textContent = e2.message; })
      .finally(function () { cta.disabled = false; if (!inCart) { cta.innerHTML = label; ctaPrice = document.getElementById('ctaPrice'); } });
  });

  /* Sticky-Leiste erst, wenn der Kaufblock aus dem Bild ist */
  var sticky = document.getElementById('sticky');
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (en) { sticky.hidden = en[0].intersectionRatio > 0.99; }, { threshold: [0, 1] }).observe(cta);
  }
  document.getElementById('stickyBtn').addEventListener('click', function () {
    if (form.requestSubmit) form.requestSubmit(); else cta.click();
  });

  /* UGC: Video erst beim Antippen laden */
  document.querySelectorAll('.ugc__card').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var v = btn.querySelector('video');
      if (!v) {
        document.querySelectorAll('.ugc__card video').forEach(function (o) { o.pause(); });
        v = document.createElement('video');
        v.src = btn.dataset.src; v.playsInline = true; v.setAttribute('playsinline', ''); v.setAttribute('webkit-playsinline', ''); v.preload = 'auto';
        v.poster = btn.querySelector('img').src;
        btn.replaceChild(v, btn.querySelector('img')); btn.classList.add('playing');
        v.play().catch(function () {});
        /* inline statt Vollbild (Stefan 19.09.) */
      } else if (v.paused) { v.play(); } else { v.pause(); }
    });
  });

  var rvMore = document.getElementById('rvMore');
  if (rvMore) rvMore.addEventListener('click', function () { document.getElementById('reviews').classList.add('rvs--open'); });

  var track = document.getElementById('galTrack');
  /* Lightbox fuer die Galerie */
  var lb = document.getElementById('lb'), lbTrack = document.getElementById('lbTrack'), lbN = document.getElementById('lbN');
  var galImgs = track ? Array.prototype.slice.call(document.querySelectorAll('#galTrack img')) : [];
  function lbCount() { var i = Math.round(lbTrack.scrollLeft / lbTrack.clientWidth); lbN.textContent = (i + 1) + ' / ' + galImgs.length; }
  galImgs.forEach(function (img, idx) {
    img.addEventListener('click', function () {
      if (!lbTrack.children.length) galImgs.forEach(function (g) { var c = document.createElement('img'); c.src = g.currentSrc || g.src; c.alt = g.alt; lbTrack.appendChild(c); });
      lb.hidden = false; document.body.style.overflow = 'hidden';
      lbTrack.scrollLeft = idx * lbTrack.clientWidth; lbCount();
    });
  });
  if (lbTrack) lbTrack.addEventListener('scroll', lbCount, { passive: true });
  function lbClose() { lb.hidden = true; document.body.style.overflow = ''; }
  if (lb) { document.getElementById('lbX').addEventListener('click', lbClose); document.addEventListener('keydown', function (e) { if (e.key === 'Escape') lbClose(); }); }

  function showCodePrice() {
    if (!window.VT_CODE) return;
    var r = current(); if (!r) return;
    var p = parseFloat(r.dataset.price.replace(/[^0-9.]/g, '')), d = (p * 0.9).toFixed(2);
    var el = document.getElementById('ctaPrice'); if (el && !inCart) el.innerHTML = '<s style="opacity:.6;font-weight:600">$' + p + '</s> $' + d;
    var sp = document.getElementById('stickyPrice'); if (sp) sp.textContent = '$' + d + ' with WELCOME10';
  }
  form.querySelectorAll('input[name="plan"]').forEach(function (r) { r.addEventListener('change', function () { setTimeout(showCodePrice, 0); }); });

  /* Rabatt-Banner: WELCOME10, 10-Minuten-Timer pro Besucher (Owner-Entscheidung 18.09.: Variante C) */
  var bar = document.getElementById('codeBar'), tEl = document.getElementById('codeTimer');
  if (bar) {
    var KEY = 'vt_code_start', start;
    try { start = parseInt(localStorage.getItem(KEY), 10); if (!start || Date.now() - start > 864e5) { start = Date.now(); localStorage.setItem(KEY, String(start)); } } catch (x) { start = Date.now(); }
    var applied = false;
    var tick = function () {
      if (applied) return;
      var left = Math.max(0, 600 - Math.floor((Date.now() - start) / 1000));
      if (left <= 0) { start = Date.now(); try { localStorage.setItem(KEY, String(start)); } catch (x) {} left = 600; } /* 19.09.: neues 10-Min-Fenster statt 'ends soon' (Owner) */
      var m = Math.floor(left / 60), sec = left % 60;
      tEl.textContent = left > 0 ? m + ':' + (sec < 10 ? '0' : '') + sec : 'ends soon';
    };
    tick(); setInterval(tick, 1000);
    bar.addEventListener('click', function () {
      try { navigator.clipboard && navigator.clipboard.writeText('WELCOME10'); } catch (x) {}
      fetch('/discount/WELCOME10', { credentials: 'same-origin' }).catch(function () {});
      try { localStorage.setItem('vt_lock_start', String(Date.now())); } catch (x) {}
      applied = true; window.VT_CODE = true; showCodePrice(); tEl.textContent = 'applied ✓'; var h = document.getElementById('codeHint'); if (h) h.textContent = 'at checkout'; bar.classList.add('codebox--on');
    });
  }

  /* Galerie-Punkte */
  var count = document.getElementById('galCount'); var n = track ? track.children.length : 0;
  if (track) track.addEventListener('scroll', function () {
    var i = Math.round(track.scrollLeft / track.clientWidth);
    if (count) count.textContent = (i + 1) + ' / ' + n;
  }, { passive: true });
})();

/* Galerie-Pfeile (Stefan 19.09.: auf Desktop sieht man nicht, dass man blaettern kann) */
(function () {
  var g = document.getElementById('gal'), t = document.getElementById('galTrack'); if (!g || !t) return;
  function mk(dir, lab) { var b = document.createElement('button'); b.type = 'button'; b.className = 'gal__arr gal__arr--' + dir; b.setAttribute('aria-label', lab); b.innerHTML = dir === 'l' ? '&#8249;' : '&#8250;';
    b.addEventListener('click', function (e) { e.stopPropagation(); t.scrollBy({ left: (dir === 'l' ? -1 : 1) * t.clientWidth, behavior: 'smooth' }); }); g.appendChild(b); return b; }
  var l = mk('l', 'Previous image'), r = mk('r', 'Next image');
  function upd() { l.hidden = t.scrollLeft < 10; r.hidden = t.scrollLeft > t.scrollWidth - t.clientWidth - 10; }
  t.addEventListener('scroll', upd, { passive: true }); upd();
})();

/* Sound-familiar: ab 3 Haken Ergebnis hervorheben + Tracking (Clarity-Events je Punkt, _sf an der Bestellung) */
(function(){var r=document.getElementById('sfRes');if(!r)return;var b=document.querySelectorAll('.sf__list input');var keys=['straw','tight_skin','brassy','pool_smell','scale','masks_fade'];
function cl(){try{if(window.clarity)window.clarity.apply(null,arguments)}catch(e){}}
b.forEach(function(x,i){x.dataset.k=keys[i]||('p'+i);x.addEventListener('change',function(){var on=[];b.forEach(function(y){if(y.checked)on.push(y.dataset.k)});window.VT_SF=on;var n=on.length;
if(x.checked){cl('event','sf_'+x.dataset.k);}cl('set','sf_count',String(n));if(n>=3)cl('event','sf_3plus');
r.classList.toggle('hit',n>=3);
r.innerHTML=n>=3?'You ticked '+n+'. <b>That\'s the pattern chlorine leaves. It\'s your water, not your hair.</b> <a href="#buy">See VATNARA →</a>':'3 or more? <b>It\'s probably your water, not your hair.</b>';});});})();
